export enum IntakeDocumentType {
  Proposal = 'Proposal',
  RequestForProposal = 'Request for Proposal (RFP)',
  EngagementLetterOrSOW = 'Engagement Letter/Statement of Work',
  InterimEngagementLetter = 'Interim Engagement Letter',
  Deliverable = 'Deliverable',
  EngagementLetter = 'Engagement Letter', // isActive: false at BE (not used),
  ExecutedEngagementLetterOrSOWOrCOOrContract = 'Executed Engagement Letter/SOW/CO/Contract',
  OriginalExecutedInterimEngagementLetter = 'Original Executed Interim Engagement Letter', // isActive: false at BE (not used)
  ConflictCheckNameMatchReport = 'Conflict Check Name Match Report',
  ConflictAnalystSummarySpreadsheet = 'Conflict Analyst summary spreadsheet of responses',
  Other = 'Other (include comments)',
  EngagementLetterOrSOWDuplicate = 'Engagement Letter/Statement of Work', // isActive: false at BE (not used), submissionTypeId: 3
  ChangeOrder = 'Change Order',
  IFA = 'IFA', // isActive: false at BE (not used)
  SubcontractorAgreement = 'Subcontractor Agreement',
}

export const IntakeDocumentIdToTypeMapper: Record<number, IntakeDocumentType> =
  {
    1: IntakeDocumentType.Proposal,
    2: IntakeDocumentType.RequestForProposal,
    3: IntakeDocumentType.EngagementLetterOrSOW,
    4: IntakeDocumentType.InterimEngagementLetter,
    5: IntakeDocumentType.Deliverable,
    6: IntakeDocumentType.EngagementLetter, // isActive: false at BE (not used)
    7: IntakeDocumentType.ExecutedEngagementLetterOrSOWOrCOOrContract,
    8: IntakeDocumentType.OriginalExecutedInterimEngagementLetter, // isActive: false at BE (not used)
    9: IntakeDocumentType.ConflictCheckNameMatchReport,
    10: IntakeDocumentType.ConflictAnalystSummarySpreadsheet,
    11: IntakeDocumentType.Other,
    12: IntakeDocumentType.EngagementLetterOrSOWDuplicate, // isActive: false at BE (not used), submissionTypeId: 3
    13: IntakeDocumentType.ChangeOrder,
    14: IntakeDocumentType.IFA, // isActive: false at BE (not used)
    15: IntakeDocumentType.SubcontractorAgreement,
  };

export const IntakeDocumentTypeToIdMapper: Record<IntakeDocumentType, number> =
  {
    [IntakeDocumentType.Proposal]: 1,
    [IntakeDocumentType.RequestForProposal]: 2,
    [IntakeDocumentType.EngagementLetterOrSOW]: 3,
    [IntakeDocumentType.InterimEngagementLetter]: 4,
    [IntakeDocumentType.Deliverable]: 5,
    [IntakeDocumentType.EngagementLetter]: 6, // isActive: false at BE (not used)
    [IntakeDocumentType.ExecutedEngagementLetterOrSOWOrCOOrContract]: 7,
    [IntakeDocumentType.OriginalExecutedInterimEngagementLetter]: 8, // isActive: false at BE (not used)
    [IntakeDocumentType.ConflictCheckNameMatchReport]: 9,
    [IntakeDocumentType.ConflictAnalystSummarySpreadsheet]: 10,
    [IntakeDocumentType.Other]: 11,
    // [IntakeDocumentType.EngagementLetterOrSOWDuplicate]: 12, // isActive: false at BE (not used), submissionTypeId: 3
    [IntakeDocumentType.ChangeOrder]: 13,
    [IntakeDocumentType.IFA]: 14, // isActive: false at BE (not used)
    [IntakeDocumentType.SubcontractorAgreement]: 15,
  };
